import {isBoolean, isInteger, isObject, isString} from 'lodash';

const state = {
  presentationID: null,
  currentPage: 1,
  pageCount: 1,
  timestamp: null,
  elapsedMS: 0,
  tabVisible: true,
  visibility: document.visibilityState,
  hasFocus: true,
}

const mutations = {
  initialize(state, meta = null) {
    state.presentationID = null;
    state.currentPage = 1;
    state.pageCount = 1;
    state.timestamp = Date.now();
    state.elapsedMS = 0;
    state.tabVisible = true;
    state.visibility = document.visibilityState;
    state.hasFocus = true;
    if (isObject(meta)) {
      if (isInteger(meta.presentationID)) {
        state.presentationID = meta.presentationID;
      }
      if (isInteger(meta.currentPage)) {
        state.currentPage = meta.currentPage;
      }
      if (isInteger(meta.pageCount)) {
        state.pageCount = meta.pageCount;
      }
    }
  },
  setCurrentPage(state, currentPage) {
    state.currentPage = currentPage;
  },
  setPresentationID(state, presentationID) {
    state.presentationID = presentationID;
  },
  setVisibility(state, visibility) {
    state.visibility = visibility;
  },
  updateMetadata(state, meta) {
    if (isBoolean(meta.tabVisible)) {
      state.tabVisible = meta.tabVisible;
    }
    if (isBoolean(meta.hasFocus)) {
      state.hasFocus = meta.hasFocus;
    }
    if (isString(meta.visibility)) {
      state.visibility = meta.visibility;
    }
    if (isInteger(meta.elapsedMS)) {
      state.elapsedMS = meta.elapsedMS;
    }
    if (isInteger(meta.timestamp)) {
      state.timestamp = meta.timestamp;
    }
  },
}

const getters = {
  presentationID: state => state.presentationID,
  currentPage: state => state.currentPage,
  pageCount: state => state.pageCount,
  timestamp: state => state.timestamp,
  elapsedMS: state => state.elapsedMS,
  tabVisible(state, getters) {
    return getters.visibility === 'visible';
  },
  visibility(state, getters) {
    return document.visibilityState;
  },
  hasFocus(state, getters) {
    return document.hasFocus();
  },
  meta: state => state,
}

const actions = {
  initialize({commit}) {
    commit('initialize');
  },
  loadDocument({commit}, meta) {
    commit('initialize', meta);
  },
  unloadDocument({commit}) {
    commit('initialize');
  },
  updateMetadata({commit, getters}, elapsed) {
    const now = Date.now();
    const diff = Math.abs(now - state.timestamp);
    const elapsedMS = isInteger(elapsed)
      ? elapsed
      : (state.elapsedMS + diff);
    const meta = {
      tabVisible: getters.tabVisible,
      hasFocus: getters.hasFocus,
      visibility: getters.visibility,
      timestamp: now,
      elapsedMS: elapsedMS,
    }
    commit('updateMetadata', meta);
    //console.log('updateMetadata', elapsedMS);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

